module.exports = __webpack_public_path__ + "img/insta.6b446a38.svg";